import { gql } from '@apollo/client'

import { PERMISSION_FRAGMENT } from '../fragments'

export const GET_PERMISSIONS = gql`
  query GetPermissions {
    permissions {
      ...Permission
    }
  }
  ${PERMISSION_FRAGMENT}
`
